import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { linksService } from './links-service';
import { session } from '../../../services/session';
import LinkToValidate from './link-to-validate';

const ValidateLinks = ({ oldLinks, selectedStory, setOldLinks, setSelectedStory, location }) => {
  const [selectedLinkIndex, setSelectedLinkIndex] = useState(null);
  const [newLinkValue, setNewLinkValue] = useState('');

  useEffect(() => {
    getSelectedStory();
  }, []);

  async function getSelectedStory() {
    if (location) {
      const urlParams = new URLSearchParams(location.search);
      const res = await linksService.getEdit(session.orgId, { edit_id: urlParams.get('edit_id') });
      setSelectedStory(res.data.data[0]);
    }
  }

  function handleSave() {
    const linksList = linksService.parseLinks(oldLinks);
    const trimmedNewValue = newLinkValue
      .split('')
      .filter(char => ![' ', '\n'].includes(char))
      .join('');
    linksList.splice(selectedLinkIndex, 1, trimmedNewValue);

    const updatedLinks = linksList.join('\n\n');
    setOldLinks(updatedLinks);
    setSelectedLinkIndex(null);
  }

  function handleClickLink(index, link) {
    setSelectedLinkIndex(index);
    setNewLinkValue(link);
  }

  const oldLinkItems = linksService
    .parseLinks(oldLinks)
    .map((link, index) => (
      <LinkToValidate
        key={index}
        link={link}
        selectedLinkIndex={selectedLinkIndex}
        index={index}
        newLinkValue={newLinkValue}
        setNewLinkValue={setNewLinkValue}
        handleSave={handleSave}
        handleClickLink={handleClickLink}
        setSelectedLinkIndex={setSelectedLinkIndex}
      />
    ));

  const disabled = !oldLinkItems.length || !selectedStory;

  const continueButtonContent = disabled ? (
    'Continue'
  ) : (
    <Link to={`/v2/publisher/${session.orgId}/links/create-links/copy-links`}>Continue</Link>
  );

  return (
    <div className="validate-links">
      <Link
        className="go-back"
        to={`/v2/publisher/${
          session.orgId
        }/links/create-links/paste-product-urls?edit_id=${selectedStory && selectedStory.edit_id}`}
      >
        <span className="arrow-left"></span>
        <span className="text">Go Back</span>
      </Link>
      <div className="content">
        <h2>Validate Links</h2>
        <div className="description">
          Click on the links below and double check that they are loading properly. If you detect
          any broken links, click “Go Back” to edit or remove your links.
        </div>
        <div className="quantity">{oldLinkItems.length} Links Detected</div>
        {oldLinkItems}
        <button className={`continue-btn ${disabled ? 'disabled' : ''}`}>
          {continueButtonContent}
        </button>
      </div>
    </div>
  );
};

export default ValidateLinks;
